// Module
var code = "<tpl if=\"online\">\n    <div class=\"listitem-user\">\n<tpl else>\n    <div class=\"listitem-user isOffline\">\n</tpl>\n    <tpl include=\"app/widgets/templates/chat/user-image-msg.tpl.html\" data=\"values\"></tpl>\n    <h3 class=\"userListSide-user-title\">{name}</h3>\n</div>\n";
// Exports
module.exports = code;